import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';
// import { useHistory } from 'react-router-dom';

function useManageSubTopics({ classID, courseID, chapterID, topicID }) {
  // const history = useHistory();
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function addTopic(data) {
    return privateFetch.post(
      `/v1/admin/class/${classID}/course/${courseID}/chapter/${chapterID}/topic/${topicID}/subtopic`,
      data
    );
  }

  function updateTopic({ subTopicID, ...data } = {}) {
    return privateFetch.put(
      `/v1/admin/class/${classID}/course/${courseID}/chapter/${chapterID}/topic/${topicID}/subtopic/${subTopicID}`,
      data
    );
  }

  function deleteTopic(subTopicID) {
    return privateFetch.delete(
      `/v1/admin/class/${classID}/course/${courseID}/chapter/${chapterID}/topic/${topicID}/subtopic/${subTopicID}`
    );
  }

  function manageSubTopics({ type, ...data } = {}) {
    if (type === 'UPDATE') {
      return updateTopic(data);
    }

    if (type === 'DELETE') {
      return deleteTopic(data?.subTopicID);
    }

    return addTopic(data);
  }

  return useMutation(manageSubTopics, {
    onSuccess() {},
    onError() {},
    onSettled() {
      queryClient.invalidateQueries('chapters');
      queryClient.invalidateQueries('subject-chapter-topics');
    },
  });
}

export default useManageSubTopics;
